import { useFetch } from "~vue/api";
import { logError, logUserInteraction } from "~vue/utils/logUtils";
import { computed, ref } from "vue";

const V1_URL = (hashid) => `/accounts/coaching_session/${hashid}`;
const V2_URL = (uuid) => `/v1/nadia2/conversations/${uuid}`;

/**
 * Composable to rename a past conversation (Nadia 1.0 OR Nadia 2.0).
 *
 * The HTTP shape differs by kind:
 *   - v1: POST /accounts/coaching_session/<hashid>      body { title }
 *   - v2: PATCH /v1/nadia2/conversations/<uuid>         body { title }
 *
 * @param {Object} args
 * @param {Function} args.onResponseCallback - Called after a successful rename.
 * @param {string} args.source - Source identifier, used for analytics.
 */
export const useRenamePastConversation = ({ onResponseCallback, source }) => {
    const activeUrl = ref(null);
    const payload = ref(null);
    const url = computed(() => activeUrl.value);

    const postFetch = useFetch(url, { immediate: false }).post(computed(() => payload.value));
    const patchFetch = useFetch(url, { immediate: false }).patch(computed(() => payload.value));

    const renamePastConversation = async ({ kind, hashid, uuid, newTitle }) => {
        payload.value = { title: newTitle };
        logUserInteraction("rename_conversation", { kind, hashid, uuid, ...(source && { source }) }, uuid);

        const fetcher = kind === "v2" ? patchFetch : postFetch;
        activeUrl.value = kind === "v2" ? V2_URL(uuid) : V1_URL(hashid);

        await fetcher.execute();

        if (fetcher.error.value) {
            logError(fetcher.error.value);
        } else {
            onResponseCallback?.();
        }
    };

    return {
        renamePastConversation,
    };
};
